module.exports = __webpack_public_path__ + "images/FUSA_icons/091-key.c2e2b9e6fcdb976e14e8e7aa832f8354.svg";